// Project lifecycle pipeline helpers — shared by Workspace + Project Detail pages.

export const STAGES = [
  { key: 'proposal', label: 'Proposal' },
  { key: 'prototype', label: 'Prototype' },
  { key: 'development', label: 'Development' },
  { key: 'testing', label: 'Testing' },
  { key: 'release', label: 'Release' },
];

export const STATUS_COLORS = {
  ready: '#10B981',
  teaser: '#0D9488',
  generating: '#F59E0B',
  failed: '#EF4444',
  available: '#EA580C',
  locked: '#94A3B8',
};

export const STATUS_LABELS = {
  ready: 'Done',
  teaser: 'Teaser live',
  generating: 'In progress',
  failed: 'Failed',
  available: 'Ready to start',
  locked: 'Locked',
};

export function computeStages({ lead, prototypes = [], builds = [] }) {
  const fullProto = prototypes.find((p) => !p.is_teaser) || null;
  const teaser = prototypes.find((p) => p.is_teaser) || null;
  const build = builds[0] || null;

  const proposal = lead && (lead.ai_proposal || lead.ai_evaluation) ? 'ready' : 'available';

  let prototype = 'available';
  if (fullProto?.status === 'ready') prototype = 'ready';
  else if (fullProto?.status === 'generating' || teaser?.status === 'generating') prototype = 'generating';
  else if (teaser?.status === 'ready') prototype = 'teaser';
  else if (fullProto?.status === 'failed' || teaser?.status === 'failed') prototype = 'failed';

  let development = 'available';
  if (build?.status === 'ready') development = 'ready';
  else if (build?.status === 'generating') development = 'generating';
  else if (build?.status === 'failed') development = 'failed';

  let testing = 'locked';
  if (build?.status === 'ready') {
    if (build.test_status === 'ready') testing = 'ready';
    else if (build.test_status === 'generating') testing = 'generating';
    else if (build.test_status === 'failed') testing = 'failed';
    else testing = 'available';
  }

  let release = 'locked';
  if (build?.status === 'ready') {
    release = build.release_status === 'ready' ? 'ready' : 'available';
  }

  return { proposal, prototype, development, testing, release, build, teaser, fullProto };
}
